import { render } from "./CallsReport.vue?vue&type=template&id=5d15bade"
import script from "./CallsReport.vue?vue&type=script&lang=js"
export * from "./CallsReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__